<template>
    <header class="header noprint">
        <div class="nav-container">
            <router-link class="logo" :to="{ name: 'Home' }" @click="closeMenu" aria-label="Home Link">
                <img src="/img/icons/favicon-32x32.png" alt="Logo" />
                <span>{{ $t('nav.title') }}</span>
            </router-link>
            <nav class="nav" :class="{ active: showMobileMenu }">
                <ul class="nav--ul__one">
                    <li class="nav-link">
                        <router-link :to="{ name: 'Home' }" @click="closeMenu" aria-label="Home Link">{{ $t('nav.home') }}</router-link>
                    </li>
                    <li class="nav-link">
                        <router-link :to="{ name: 'NominateTeacher' }" @click="closeMenu" aria-label="Nominate a teacher link">{{ $t('nav.nominate_teacher') }}</router-link>
                    </li>
                    <li class="nav-link">
                        <router-link :to="{ name: 'ThankYou' }" @click="closeMenu" aria-label="Thank you page link">{{ $t('nav.thank_yous') }}</router-link>
                    </li>
                    <template v-if="authUser">
                        <li class="nav-link">
                            <router-link :to="{ name: 'Blog' }" @click="closeMenu" aria-label="Blog Link">{{ $t('nav.blog') }}</router-link>
                        </li>
                        <li class="nav-link" v-if="isAdminUser">
                            <router-link :to="{ name: 'Approvals' }" @click="closeMenu" aria-label="Approvals Link">{{ $t('nav.approvals') }}</router-link>
                        </li>
                    </template>
                </ul>
                <ul class="nav--ul__two">
                    <li class="nav-link" v-if="authUser">
                        <button @click="signUserOut" class="pill" aria-label="Logout Link">{{ $t('nav.logout') }}</button>
                    </li>
                    <li class="nav-link" v-else>
                        <router-link :to="{ name: 'Login' }" @click="closeMenu" aria-label="Login Link">{{ $t('nav.login') }}</router-link>
                    </li>
                </ul>
            </nav>
            <span class="hamburger-menu  material-symbols-outlined" @click="showMenu" aria-label="Open Mobil Menu">menu</span>
        </div>
    </header>
</template>

<script>
import { ref } from 'vue'
import getUser from '@/composables/user/get_user'
import useSignout from '@/composables/user/sign_out'
import { useRouter } from 'vue-router'

export default {
    setup() {
        const showMobileMenu = ref(false)
        const { authUser, dbUser, isAdminUser, } = getUser()
        const { logOut } = useSignout()
        const router = useRouter()

        /**
         * Hides and shows the mobile nav menu.
         */
        const showMenu = () => {
            showMobileMenu.value = !showMobileMenu.value
        }

        /**
         * Button to go to the home page.
         */
        const goHome = () => {
            closeMenu()
            router.push({ name: 'Home' })
        }
        
        /**
         * Button to log out then go to the home page.
         */
        const signUserOut = async () => {
            await logOut()
            closeMenu()
            router.push({ name: 'Home' })
        }

        const closeMenu = () => {
            console.log('close menu')
            showMobileMenu.value = false
        }

        return {
            showMobileMenu,
            showMenu,
            authUser,
            logOut,
            goHome,
            signUserOut,
            dbUser,
            isAdminUser,
            closeMenu,
        }
    }
}
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0");
@import "../../assets//styles/widths.scss";

header {
    background: black;
    padding: .5rem 0;

    .nav-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 90%;
        margin: 0 auto;

        .logo {
            font-size: 2rem; 
            font-weight: bold;

            img {
                margin-right: 1rem;
                margin-top: 0.25rem;
            }
        }

        .nav {
            display: flex;
            flex-grow: 1;

            .nav-link {
                a {
                    text-decoration: none;

                    &:hover {
                        text-decoration: underline;
                    }
                }
            }

            &--ul__one {
                margin: 0 auto;
            }
        }
    }
}

.nav-container, 
.nav--ul__one,
.nav--ul__two {
    display: flex;
    gap: 1.6rem;
    font-size: 1.2rem;

    button {
        padding: .5rem 1rem;
        border: none;
        background: white;
        color: black;
        border-radius: 1rem;
        cursor: pointer;
    }
}

.hamburger-menu {
    display: none; /* Hidden by default for larger screens */
    cursor: pointer;
}

ul {
    list-style: none;
}

@media (max-width: $smallDevice) {
    .header {
        .nav-container {
            .logo {
                font-size: 1.2rem;
                z-index: 2;
            }
            
            .nav {
                display: none;
                flex-direction: column;
                gap: 2rem;
                position: absolute;
                top: 0;
                right: -100%;
                bottom: 0;
                width: 100%;
                padding-top: 6rem;
                align-items: center;
                text-align: center;
                background-color: black;
                transition: 0.15s ease-in-out;

                &--ul__one,
                &--ul__two {
                    flex-direction: column;
                    gap: .6rem;
                }

                &.active {
                    right: 0;
                    display: block;
                }
            }
            
            .hamburger-menu {
                display: block;
                z-index: 2;
            }
        }
    }
}
</style>
